'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowExpanderRight, iconArrowExpanderRightTag } from '@ni/nimble-components/dist/esm/icons/arrow-expander-right';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowExpanderRight };
export { iconArrowExpanderRightTag };
export const NimbleIconArrowExpanderRight = wrap(IconArrowExpanderRight);